import React, { FC, ReactNode } from 'react'
import { Typography, Button } from '@mui/material'
import { useHistory } from 'react-router-dom'

import { StackLayout } from '../StackLayout'
import { CardItem } from '../CardItem'
import { useStyles } from './styles'

interface Props {
  pageTitle: string
  backAction?: boolean
  backUrl?: string
  children?: ReactNode
}

export const StandardPage: FC<Props> = ({
  children,
  pageTitle,
  backAction,
  backUrl
}) => {
  const history = useHistory()
  const styles = useStyles()

  const handleGoBack = () => {
    if (backUrl) {
      history.push(backUrl)
    } else {
      history.goBack()
    }
  }

  return (
    <StackLayout hasTitle={!!pageTitle}>
      {pageTitle && (
        <div className={styles.container}>
          <Typography variant='h5' component='h1'>
            {pageTitle}
          </Typography>
          {backAction && (
            <Button variant='text' onClick={handleGoBack}>
              Volver
            </Button>
          )}
        </div>
      )}

      {React.Children.map(children, (child) => {
        if (child === null) return null

        return <CardItem>{child}</CardItem>
      })}
    </StackLayout>
  )
}
